import * as React from 'react';
import { SubmissionsProps } from './Submissions';
import { SubmissionState } from '../interface/SubmissionInterface';
import EmpItemContent from './EmpItemContent';
import Select from 'react-select';

class EmpItem extends React.Component<SubmissionsProps, SubmissionState>{
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            checkAll: false,
            isChecked: false,
            selectedOption: "Choose one to change",
            selectedOptionAll: null
        };
    }
    onClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
    
    onCheckAllChange = () => {
        this.setState({ checkAll: !this.state.checkAll });
    }
    
    handleChangeAll = (selectedOption) => {
        this.setState({ selectedOption });
    }
    
    onApply = () => {
        this.setState({ checkAll: false });
        this.setState({ selectedOptionAll: this.state.selectedOption });
        //post data to db
    }
    
    public render() {
        const options = [
            { value: 'undergraduate', label: 'Undergraduate' },
            { value: 'graduate student', label: 'Graduate Student' },
            { value: 'post graduate research', label: 'Post Graduate Research' },
            { value: 'faculty', label: 'Faculty' },
            { value: 'other student', label: 'Other Student' },
            { value: 'staff', label: 'Staff' },
        ]
        
        return <tbody>
            <tr className="rowItem">
                <td style={{ fontWeight: this.state.isOpen ? "bold" : "normal" }}>
                    <input
                        type="checkbox"
                        onChange={this.onCheckAllChange}
                        checked={this.state.checkAll}
                    />&nbsp;&nbsp;{this.props.item}</td><td></td><td></td><td></td><td></td><td></td><td onClick={this.onClick}>{this.state.isOpen ? <i className="fa fa-minus"></i> : <i className="fa fa-plus"></i>}</td>
            </tr>
            {this.state.isOpen &&
                this.props.bodyData.map((bodyItem, i) => {
                    return <EmpItemContent bodyItem={bodyItem} key={bodyItem.epss_classification_pk} checkAll={this.state.checkAll} selectedOptionAll={this.state.selectedOptionAll} />
                })
            }
            {this.state.checkAll ?
                <tr><td></td><td></td><td style={{
                    color: '#063059', fontWeight: 'bold'
                }}>Change EPSS CLASSIFICATION for selected list:</td><td><Select
                    className="epss-select"
                    value={this.state.selectedOption}
                    onChange={this.handleChangeAll}
                    options={options}
                /></td><td></td><td><button onClick={this.onApply}>Apply</button></td><td></td></tr> : null}
        </tbody>
    }
}
export default EmpItem;